import { Component, h } from '@stencil/core'

import animation from './animation.png'

@Component({
  tag: 'ui-loader',
})
export class Loader {
  render() {
    return <img style={{ width: '1em' }} src={animation} />
  }
}
